import { render, staticRenderFns } from "./usersPage.vue?vue&type=template&id=654e5f9e&"
import script from "./usersPage.vue?vue&type=script&lang=ts&"
export * from "./usersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports